import { FormHelperText, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiFormLabel-root.Mui-error': {
    color: theme.palette.pink,
  },
  '& .MuiInput-underline.Mui-error:after': {
    borderBottomColor: theme.palette.pink,
  },
}));

export const StyledHelperText = styled(FormHelperText)(({ theme }) => ({
  color: `${theme.palette.pink} !important`,
}));
